import logger from './logger';
import { NotificationType } from '../contexts/NotificationContext';

export const copyToClipboard = async (
    text: string, 
    showNotification: (message: string, type?: NotificationType, duration?: number) => void,
    successMessage?: string, 
    errorMessage?: string
  ): Promise<boolean> => {

  if (!navigator.clipboard) {
    logger.error('Clipboard API not available.');
    // alert('Clipboard API not available in your browser.');
    showNotification('Clipboard API not available in your browser.', 'error');
    return false;
  }
  try {
    await navigator.clipboard.writeText(text);
    logger.info(successMessage || 'Text copied to clipboard!');
    // alert(successMessage || 'Text copied to clipboard!'); // Or use a toast notification
    showNotification(successMessage || 'Text copied to clipboard!', 'success');
    return true;
  } catch (err) {
    logger.error(errorMessage || 'Failed to copy text: ', err);
    // alert(errorMessage || 'Failed to copy text. See console for details.');
    showNotification(errorMessage || 'Failed to copy text. See console for details.', 'error');
    return false;
  }
};

export const copyImageToClipboard = async (
    blob: Blob | null,
    showNotification: (message: string, type?: NotificationType, duration?: number) => void,
    successMessage?: string,
    errorMessage?: string
  ): Promise<boolean> => {
    
    if (!navigator.clipboard || !navigator.clipboard.write) {
      logger.error('Clipboard API for writing images not available.');
      showNotification('Clipboard API for images not available in your browser.', 'error');
      return false;
    }
    if (!blob) {
      showNotification(errorMessage || 'No image data to copy.', 'warning');
      return false;
    }
    try {
      const item = new ClipboardItem({ [blob.type]: blob });
      await navigator.clipboard.write([item]);
      showNotification(successMessage || 'Image copied to clipboard!', 'success');
      return true;
    } catch (err) {
      logger.error(errorMessage || 'Failed to copy image: ', err);
      showNotification(errorMessage || 'Failed to copy image. See console for details.', 'error');
      return false;
    }
  };